import { defineComponent as J, useId as Q, useTemplateRef as I, inject as V, ref as T, createElementBlock as F, openBlock as K, mergeProps as W, unref as o, renderSlot as N, Fragment as Z, createElementVNode as b, normalizeClass as R } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Drawer/drawer.js";
import { c_drawer__panel_md_FlexBasis as ee } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_drawer__panel_md_FlexBasis.js";
import { c_drawer__panel_md_FlexBasis_min as te } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_drawer__panel_md_FlexBasis_min.js";
import { c_drawer__panel_md_FlexBasis_max as oe } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_drawer__panel_md_FlexBasis_max.js";
import { DrawerContentRefKey as ne } from "./DrawerContent.vue2.js";
import { DrawerKey as re } from "./common.js";
import { resolveOverridableComponent as ie } from "../../helpers/index.js";
import { isDefined as ae } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as le } from "../../helpers/ouia.js";
const se = ["id", "hidden"], ue = ["aria-orientation", "aria-label", "aria-valuenow", "aria-controls"], be = /* @__PURE__ */ J({
  name: "PfDrawerPanelContent",
  __name: "DrawerPanelContent",
  props: {
    id: { default: () => Q() },
    noBorder: { type: Boolean },
    resizable: { type: Boolean },
    minSize: {},
    defaultSize: {},
    maxSize: {},
    increment: { default: 5 },
    resizeAriaLabel: { default: "Resize" },
    widths: {},
    colorVariant: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["resize"],
  setup(U, { expose: O, emit: $ }) {
    const i = U, X = le({ id: i.ouiaId, safe: i.ouiaSafe }), h = $, m = I("panelRef"), y = V(re);
    if (!y)
      throw new Error("DrawerPanelContent can only be used inside Drawer components");
    const { el: g, position: n, expanded: B, display: Y, inline: P } = y, w = V(ne), j = I("splitterRef");
    let u = null;
    const d = T();
    let f, c = !0;
    const z = T(0);
    function S() {
      var _, M, k;
      let e, t;
      const r = ie(w == null ? void 0 : w.value), p = ((_ = m.value) == null ? void 0 : _.getBoundingClientRect()) ?? { left: 0, right: 0 }, a = ((M = j.value) == null ? void 0 : M.getBoundingClientRect()) ?? { left: 0, right: 0, top: 0 }, v = ((k = g.value) == null ? void 0 : k.getBoundingClientRect()) ?? { left: 0, right: 0 }, s = (r == null ? void 0 : r.getBoundingClientRect()) ?? { left: 0, right: 0, top: 0, bottom: 0 };
      if (P.value && n.value === "end")
        e = p.right - a.left, t = v.right - v.left;
      else if (P.value && n.value === "start")
        e = a.right - p.left, t = v.right - v.left;
      else if (n.value === "end")
        e = s.right - a.left, t = s.right - s.left;
      else if (n.value === "start")
        e = a.right - s.left, t = s.right - s.left;
      else if (n.value === "bottom")
        e = s.bottom - a.top, t = s.bottom - s.top;
      else
        return 0;
      const G = e / t * 100;
      return Math.round((G + Number.EPSILON) * 100) / 100;
    }
    function H(e) {
      e.stopPropagation(), document.addEventListener("touchmove", L, { passive: !1 }), document.addEventListener("touchend", A), u = !0;
    }
    function q(e) {
      var t;
      e.stopPropagation(), e.preventDefault(), document.addEventListener("mousemove", E), document.addEventListener("mouseup", C), (t = g.value) == null || t.classList.add(l.modifiers.resizing), u = !0, c = !0;
    }
    function E(e) {
      const t = n.value === "bottom" ? e.clientY : e.clientX;
      D(e, t);
    }
    function L(e) {
      e.preventDefault(), e.stopImmediatePropagation();
      const t = n.value === "bottom" ? e.touches[0].clientY : e.touches[0].clientX;
      D(e, t);
    }
    function D(e, t) {
      if (e.stopPropagation(), !u || !m.value)
        return;
      c && (f = m.value.getBoundingClientRect(), c = !1);
      let r = 0;
      n.value === "end" ? r = f.right - t : n.value === "start" ? r = t - f.left : r = f.bottom - t, d.value = r, z.value = S();
    }
    function C() {
      var e;
      u && ((e = g.value) == null || e.classList.remove(l.modifiers.resizing), u = !1, h("resize", d.value ?? 0, i.id), c = !0, document.removeEventListener("mousemove", E), document.removeEventListener("mouseup", C));
    }
    function A(e) {
      e.stopPropagation(), u && (u = !1, h("resize", d.value ?? 0, i.id), document.removeEventListener("touchmove", L), document.removeEventListener("touchend", A));
    }
    function x(e) {
      if (!m.value)
        return;
      const t = e.key;
      if (t !== "Escape" && t !== "Enter" && t !== "ArrowUp" && t !== "ArrowDown" && t !== "ArrowLeft" && t !== "ArrowRight") {
        u && e.preventDefault();
        return;
      }
      e.preventDefault(), (t === "Escape" || t === "Enter") && h("resize", d.value ?? 0, i.id);
      const r = m.value.getBoundingClientRect(), p = n.value === "bottom" ? r.height : r.width;
      let a = 0;
      t === "ArrowRight" ? a = n.value === "start" ? i.increment : -i.increment : t === "ArrowLeft" ? a = n.value === "start" ? -i.increment : i.increment : t === "ArrowUp" ? a = i.increment : t === "ArrowDown" && (a = -i.increment), d.value = p + a, z.value = S();
    }
    return O({
      expanded: B
    }), (e, t) => (K(), F("div", W(o(X), {
      id: e.id,
      ref: "panelRef",
      class: [o(l).drawerPanel, {
        [o(l).modifiers.resizable]: e.resizable,
        [o(l).modifiers.noBorder]: e.noBorder,
        [o(l).modifiers.noBackground]: e.colorVariant === "no-background",
        [o(l).modifiers.secondary]: e.colorVariant === "secondary"
      }],
      style: {
        display: o(Y) ? "inherit" : "none",
        [o(ee).name]: o(ae)(d.value) ? `${d.value}px` : e.defaultSize,
        [o(te).name]: e.minSize,
        [o(oe).name]: e.maxSize,
        overflowAnchor: o(n) === "bottom" ? "none" : void 0
      },
      hidden: !o(B)
    }), [
      e.resizable ? (K(), F(Z, { key: 0 }, [
        b("div", {
          ref: "splitterRef",
          class: R([o(l).drawerSplitter, { [o(l).modifiers.vertical]: o(n) !== "bottom" }]),
          role: "separator",
          tabindex: "0",
          "aria-orientation": o(n) === "bottom" ? "horizontal" : "vertical",
          "aria-label": e.resizeAriaLabel,
          "aria-valuenow": z.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-controls": e.id,
          onMousedown: t[0] || (t[0] = (r) => q(r)),
          onKeydown: x,
          onTouchstart: H
        }, [
          b("div", {
            class: R(o(l).drawerSplitterHandle),
            "aria-hidden": ""
          }, null, 2)
        ], 42, ue),
        b("div", {
          class: R(o(l).drawerPanelMain)
        }, [
          N(e.$slots, "default")
        ], 2)
      ], 64)) : N(e.$slots, "default", { key: 1 })
    ], 16, se));
  }
});
export {
  be as default
};
